import { render, staticRenderFns } from "./IpoResultLockupRow.vue?vue&type=template&id=2bde57b8&scoped=true"
import script from "./IpoResultLockupRow.vue?vue&type=script&lang=js"
export * from "./IpoResultLockupRow.vue?vue&type=script&lang=js"
import style0 from "./IpoResultLockupRow.vue?vue&type=style&index=0&id=2bde57b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde57b8",
  null
  
)

export default component.exports